import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'

// ** Icon Imports
import Icon from 'src/@core/components/icon'
import Image from 'next/image'

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  borderRadius: 1,
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover
}))

const TextMessagesContent = props => {
  // ** Props
  const {
    data,
    store,
    hidden,
    sendMsg,
    mdAbove,
    dispatch,
    getInitials,
    sidebarWidth,
    callData,
    userProfileRightOpen,
    handleLeftSidebarToggle,
    handleUserProfileRightSidebarToggle
  } = props

  const handleStartConversation = () => {
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const renderContent = () => {
    if (store) {
      const selectedMessage = store.selectedMessage

      if (!selectedMessage) {
        return (
          <ChatWrapperStartChat
            sx={{
              ...(mdAbove ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : {})
            }}
          >
            <Box
              onClick={handleStartConversation}
              sx={{
                px: 6,
                py: 2.25,
                boxShadow: 3,
                borderRadius: 5,
                backgroundColor: 'background.paper',
                cursor: mdAbove ? 'default' : 'pointer'
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>Start Conversation</Typography>
            </Box>
          </ChatWrapperStartChat>
        )
      } else {
        return (
          <>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                height: '100%',
                backgroundColor: 'white'
              }}
            >
              <div className='h-[20px] bg-[#f1f3f5]'></div>
              <Box
                sx={{
                  py: 3,
                  px: 5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: theme => `1px solid ${theme.palette.divider}`,
                  backgroundColor: '#f1f3f5',
                  height: 50
                }}
                className='border-b-[1px] border-t'
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {mdAbove ? null : (
                    <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2 }}>
                      <Icon icon='mdi:menu' />
                    </IconButton>
                  )}
                  <Box
                    onClick={handleUserProfileRightSidebarToggle}
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography sx={{ color: 'text.secondary', fontWeight: 700, color: 'black' }}>Calls</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <div className='overflow-auto h-[90%] bg-white'>
                {callData.calls.map(item => {
                  return (
                    <div
                      key={item.id}
                      className='w-9/12  mx-auto flex justify-between items-center mt-6 border-b-[1px] border-[#f3f5f9] '
                    >
                      <div className='flex items-center p-1'>
                        <div className='w-[40px] rounded-full'>
                          <Image src={item.img} alt='img' width={100} height={40} className=' rounded-full' />
                        </div>
                        <div className='ml-3'>
                          <div>
                            <h2 className='text-[15px] text-[#53a2ec] font-semibold'>{item.name}</h2>
                          </div>
                          <div className='flex mt-1'>
                            <div>
                              <Icon
                                icon={item.icon}
                                className='text-blue-500'
                                width={15}
                                style={{ color: item.state === -1 ? 'red' : '' }}
                              />
                            </div>
                            <div>
                              <h2 className='text-[12px] ml-2 text-[#4d5976] font-medium text-opacity-80'>
                                {item.time}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h2 className='text-[13px] font-bold text-black text-opacity-60'>{item.Time}</h2>
                      </div>
                    </div>
                  )
                })}
              </div>

              {/* <SendMsgForm store={store} dispatch={dispatch} sendMsg={sendMsg} /> */}
            </Box>
          </>
        )
      }
    } else {
      return null
    }
  }

  return renderContent()
}

export default TextMessagesContent
